import { useEffect, useRef, useState } from "react";
import { Box, Paper } from "@mui/material";

export default function YouTubePlayer({ url }) {
  const containerRef = useRef(null);
  const playerRef = useRef(null);
  const [videoId, setVideoId] = useState(null);
  const [playerReady, setPlayerReady] = useState(false);

  // Extract YouTube video ID
  useEffect(() => {
    setVideoId(getYouTubeId(url));
  }, [url]);

  // Load YouTube IFrame API
  useEffect(() => {
    if (window.YT && window.YT.Player) return;

    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);
  }, []);

  // Initialize YouTube player
  useEffect(() => {
    if (!videoId) return;

    const createPlayer = () => {
      if (playerRef.current) return;

      playerRef.current = new window.YT.Player("youtube-player", {
        videoId,
        playerVars: {
          autoplay: 1,
          controls: 1,
          rel: 0,
        },
        events: {
          onReady: () => {
            setPlayerReady(true);
          },
          // onStateChange: (event) => {
          //   if (event.data === window.YT.PlayerState.ENDED) {
          //     if (
          //       playerRef.current &&
          //       typeof playerRef.current.playVideo === "function"
          //     ) {
          //       playerRef.current.seekTo(0);
          //       playerRef.current.playVideo();
          //     }
          //   }
          // },
        },
      });
    };

    if (window.YT && window.YT.Player) {
      createPlayer();
    } else {
      window.onYouTubeIframeAPIReady = createPlayer;
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
        playerRef.current = null;
      }
      delete window.onYouTubeIframeAPIReady;
    };
  }, [videoId]);

  // Pause/resume video on tab visibility change
  useEffect(() => {
    function handleVisibilityChange() {
      if (!playerRef.current || !playerReady) return;

      if (document.hidden) {
        playerRef.current.pauseVideo?.();
      } else {
        playerRef.current.playVideo?.();
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [playerReady]);

  if (!videoId) {
    return (
      <Box
        sx={{
          width: "100%",
          aspectRatio: "16 / 9",
          bgcolor: "grey.200",
          borderRadius: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "text.secondary",
          mb: 2,
        }}
      >
        Invalid YouTube URL
      </Box>
    );
  }

  return (
    <Paper
      elevation={3}
      sx={{
        width: "100%",
        aspectRatio: "16 / 9",
        mb: 2,
        overflow: "hidden",
        borderRadius: 2,
        position: "relative",
      }}
    >
      <div
        id="youtube-player"
        ref={containerRef}
        style={{ width: "100%", height: "100%" }}
      />
    </Paper>
  );
}

// Utility: Extract YouTube video ID from URL
function getYouTubeId(url) {
  try {
    const u = new URL(url);
    if (u.searchParams.has("v")) {
      return u.searchParams.get("v");
    }
    const paths = u.pathname.split("/");
    return paths[paths.length - 1];
  } catch (e) {
    console.warn("Invalid YouTube URL:", url);
    return null;
  }
}


// import { useEffect, useRef, useState } from "react";
// import { Box, Paper } from "@mui/material";

// export default function YouTubePlayer({ url }) {
//   const containerRef = useRef(null);
//   const playerRef = useRef(null);
//   const [videoId, setVideoId] = useState(null);
//   const [playerReady, setPlayerReady] = useState(false);

//   // Extract YouTube video ID once
//   useEffect(() => {
//     setVideoId(getYouTubeId(url));
//   }, [url]);

//   // Load YouTube Iframe API once
//   useEffect(() => {
//     if (window.YT) return;

//     const tag = document.createElement("script");
//     tag.src = "https://www.youtube.com/iframe_api";
//     document.body.appendChild(tag);
//   }, []);

//   // Initialize player when YT API ready and videoId is available
//   useEffect(() => {
//     if (!videoId) return;

//     // This function is called by YouTube API when ready
//     window.onYouTubeIframeAPIReady = () => {
//       playerRef.current = new window.YT.Player("youtube-player", {
//         videoId,
//         playerVars: {
//           autoplay: 1,
//           controls: 1,
//           rel: 0,
//         },
   
//         events: {
//           onReady: () => setPlayerReady(true),
//         },
//       });
//     };

//     // If API already loaded before this component mounted
//     if (window.YT && window.YT.Player && !playerRef.current) {
//       playerRef.current = new window.YT.Player("youtube-player", {
//         videoId,
//         playerVars: {
//           autoplay: 1,
//           controls: 1,
//           rel: 0,
//         },
//         events: {
//           onReady: () => setPlayerReady(true),
//         },
//       });
//     }

//     return () => {
//       // Cleanup player on unmount
//       if (playerRef.current) {
//         playerRef.current.destroy();
//         playerRef.current = null;
//       }
//       // Remove global callback
//       delete window.onYouTubeIframeAPIReady;
//     };
//   }, [videoId]);

//   // Handle tab visibility: pause/resume video
//   useEffect(() => {
//     function handleVisibilityChange() {
//       if (!playerRef.current || !playerReady) return;

//       if (document.hidden) {
//         playerRef.current.pauseVideo();
//       } else {
//         playerRef.current.playVideo();
//       }
//     }

//     document.addEventListener("visibilitychange", handleVisibilityChange);

//     return () => {
//       document.removeEventListener("visibilitychange", handleVisibilityChange);
//     };
//   }, [playerReady]);

//   if (!videoId) {
//     return (
//       <Box
//         sx={{
//           width: "100%",
//           aspectRatio: "16 / 9",
//           bgcolor: "grey.200",
//           borderRadius: 1,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           color: "text.secondary",
//           mb: 2,
//         }}
//       >
//         Invalid YouTube URL
//       </Box>
//     );
//   }

//   return (
//     <Paper
//       elevation={3}
//       sx={{
//         width: "100%",
//         aspectRatio: "16 / 9",
//         mb: 2,
//         overflow: "hidden",
//         borderRadius: 2,
//         position: "relative",
//       }}
//     >
//       <div
//         id="youtube-player"
//         ref={containerRef}
//         style={{ width: "100%", height: "100%" }}
//       />
//     </Paper>
//   );
// }

// function getYouTubeId(url) {
//   try {
//     const u = new URL(url);
//     if (u.searchParams.has("v")) {
//       return u.searchParams.get("v");
//     }
//     const paths = u.pathname.split("/");
//     return paths[paths.length - 1];
//   } catch (e) {
//     console.warn("Invalid YouTube URL:", url);
//     return null;
//   }
// }










// import Box from "@mui/material/Box";
// import { Paper } from "@mui/material";

// export default function YouTubePlayer({ url }) {
//   const videoId = getYouTubeId(url);

//   if (!videoId) {
//     return (
//       <Box
//         sx={{
//           width: "100%",
//           aspectRatio: "16 / 9",
//           bgcolor: "grey.200",
//           borderRadius: 1,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           color: "text.secondary",
//           mb: 2,
//         }}
//       >
//         Invalid YouTube URL
//       </Box>
//     );
//   }

//   return (
// <Paper
//   elevation={3}
//   sx={{
//     width: "100%",
//     aspectRatio: "16 / 9", // ensures 16:9 ratio across all screens
//     mb: 2,
//     overflow: "hidden",
//     borderRadius: 2,
//   }}
// >
//   <iframe
//     width="100%"               // responsive width
//     height="100%"              // full height based on aspect ratio
//     src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&rel=0`}
//     title="YouTube video player"
//     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//     allowFullScreen
//     style={{ border: 0 }}
//   ></iframe>
// </Paper>

//   );
// }

// function getYouTubeId(url) {
//   try {
//     const u = new URL(url);
//     if (u.searchParams.has("v")) {
//       return u.searchParams.get("v");
//     }
//     const paths = u.pathname.split("/");
//     return paths[paths.length - 1];
//   } catch (e) {
//     console.warn("Invalid YouTube URL:", url);
//     return null;
//   }
// }
